// extracted by mini-css-extract-plugin
module.exports = {"calculatorsCards":"Calculators_calculatorsCards__vB2lg","calculatorsCard":"Calculators_calculatorsCard__3oEYA"};